import { Routes } from "@angular/router";
import { checkMembershipPermissions } from "../shared/guards/auth-guard.guard";
import { maintenanceGuard } from "../shared/guards/auth-guard.guard";

// All settings components are lazy-loaded — they're behind auth and never part
// of the initial bundle for /shop or /home.
export const settingsRoutes: Routes = [
  {
    path: 'settings',
    title: 'Settings',
    loadComponent: () => import('./settings.component').then(m => m.SettingsComponent),
    canActivate: [maintenanceGuard, checkMembershipPermissions],
    canActivateChild: [maintenanceGuard],
    children: [
      {
        path: 'account/profile',
        title: 'Profile settings',
        loadComponent: () => import('./account/profile/profile.component').then(m => m.ProfileComponent),
      },
      {
        path: 'account/subscriptions',
        title: 'Subscription manager',
        loadComponent: () => import('./account/subscriptions/subscriptions.component').then(m => m.SubscriptionsComponent),
      },
      {
        path: 'account/friend-referrals',
        title: 'Friend referrals',
        loadComponent: () => import('./account/friend-referrals/friend-referrals.component').then(m => m.FriendReferralsComponent),
      },
      {
        path: 'billing/payment-method',
        title: 'Payment method settings',
        loadComponent: () => import('./billing/payment-method/payment-method.component').then(m => m.PaymentMethodComponent),
      },
      {
        path: 'billing/membership',
        title: 'Membership',
        loadComponent: () => import('./billing/membership/membership.component').then(m => m.MembershipComponent),
      },
      {
        path: 'billing/order-and-billing',
        title: 'Order & billing',
        loadComponent: () => import('./billing/order-and-billing/order-and-billing.component').then(m => m.OrderAndBillingComponent),
      },
      {
        path: 'billing/order-and-billing/:order',
        title: 'Order detail',
        loadComponent: () => import('./billing/order-and-billing/order-detail/order-detail.component').then(m => m.OrderDetailComponent),
      },
      {
        path: 'billing/invoice-history',
        title: 'Invoice History',
        loadComponent: () => import('./billing/invoice-history/invoice-history.component').then(m => m.InvoiceHistoryComponent),
      }
    ]
  },
];
